import { ProfileAdapter } from './Profile.reducer';

export const ProfileSelector = {
  ...ProfileAdapter.getSelectors((state: any) => state.profiles),
};
